import { jsx as _jsx } from "react/jsx-runtime";
import cloneDeep from "clone-deep";
import _merge from "lodash/merge.js";
import { Suspense, lazy } from "react";
import { SearcherId } from "../../../../../../types/common/searchers.js";
import { SearcherModalProductType } from "../../types.js";
import useSearcherModal from "./hooks/useSearcherModal.js";
import * as S from "./styled.js";
import { renderSearcherSkeleton } from "./utils.js";
const SearcherFerryHotelDesktop = /*#__PURE__*/ lazy(()=>import("../../../searcher-ferry-hotel/views/desktop/index.js"));
const SearcherFerDesktop = /*#__PURE__*/ lazy(()=>import("../../../searcher-fer/views/desktop/index.js"));
const SearcherFliDesktop = /*#__PURE__*/ lazy(()=>import("../../../searcher-fli/views/desktop/index.js"));
const SearcherFlightHotelDesktop = /*#__PURE__*/ lazy(()=>import("../../../searcher-flight-hotel/views/desktop/index.js"));
const SearcherTrainHotelDesktop = /*#__PURE__*/ lazy(()=>import("../../../searcher-train-hotel/views/desktop/index.js"));
const SearcherActivitiesDesktop = /*#__PURE__*/ lazy(()=>import("../../../searcher-activities/views/desktop/index.js"));
const SearcherModalDesktop = (props)=>{
    const { flightHotelData , trainHotelData , ferryHotelData , fliData , ferData , activitiesData , loading , config , product  } = useSearcherModal(props);
    const renderSearcher = (Searcher, searcherId, data)=>{
        if (loading) return renderSearcherSkeleton(searcherId, {
            onModal: true
        });
        if (!data) return null;
        const props = _merge(cloneDeep(data), {
            config
        });
        return /*#__PURE__*/ _jsx(Suspense, {
            fallback: renderSearcherSkeleton(searcherId, {
                onModal: true
            }),
            children: /*#__PURE__*/ _jsx(Searcher, {
                props: props
            })
        });
    };
    const SearcherModalType = {
        [SearcherModalProductType.ROUNDTRIP]: {
            render: ()=>renderSearcher(SearcherFliDesktop, SearcherId.FLI, fliData)
        },
        [SearcherModalProductType.ONEWAY]: {
            render: ()=>renderSearcher(SearcherFliDesktop, SearcherId.FLI, fliData)
        },
        [SearcherModalProductType.FLIGHTHOTEL]: {
            render: ()=>renderSearcher(SearcherFlightHotelDesktop, SearcherId.FLI_HOT, flightHotelData)
        },
        [SearcherModalProductType.TRAINHOTEL]: {
            render: ()=>renderSearcher(SearcherTrainHotelDesktop, SearcherId.TRA_HOT, trainHotelData)
        },
        [SearcherModalProductType.FERRYHOTEL]: {
            render: ()=>renderSearcher(SearcherFerryHotelDesktop, SearcherId.FER_HOT, ferryHotelData)
        },
        [SearcherModalProductType.ACTIVITIES]: {
            render: ()=>renderSearcher(SearcherActivitiesDesktop, SearcherId.ACTIVITIES, activitiesData)
        },
        [SearcherModalProductType.FERRY]: {
            render: ()=>renderSearcher(SearcherFerDesktop, SearcherId.FER, ferData)
        },
        [SearcherModalProductType.SEARCHER_FLIGHT_HOTEL]: {
            render: ()=>renderSearcher(SearcherFlightHotelDesktop, SearcherId.FLI_HOT, flightHotelData)
        },
        [SearcherModalProductType.SEARCHER_TRAIN_HOTEL]: {
            render: ()=>renderSearcher(SearcherTrainHotelDesktop, SearcherId.TRA_HOT, trainHotelData)
        },
        [SearcherModalProductType.SEARCHER_FERRY_HOTEL]: {
            render: ()=>renderSearcher(SearcherFerryHotelDesktop, SearcherId.FER_HOT, ferryHotelData)
        },
        [SearcherModalProductType.SEARCHER_ACTIVITIES]: {
            render: ()=>renderSearcher(SearcherActivitiesDesktop, SearcherId.ACTIVITIES, activitiesData)
        }
    };
    return /*#__PURE__*/ _jsx(S.SearcherModalWrapper, {
        "data-testid": "SearcherModal",
        children: product && SearcherModalType[product]?.render()
    });
};
export default SearcherModalDesktop;

//# sourceMappingURL=index.js.map